import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalTemplate  {
    _originalTypeClassName = "zERP.BO.GeneralJournalTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalTemplate.translate = translateService;
}
this.Details = [];
this.Entity = new Domain.AccountingBusinessEntity();
this.AccountingJournal = new Domain.AccountingJournal();
this.Id = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Ledger:any;
Details:any;
Entity:any;
FiscalPeriod:any;
AccountingJournal:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.GeneralJournalTemplate.removeDetails($this, $this.Details[0]);
                }

                Domain.GeneralJournalTemplate.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalTemplate.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalTemplate.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
}
static clearDetails = ($this) => { $this.Details = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setAccountingJournal = ($this, value) => {
var oldValue = $this.AccountingJournal;
$this.AccountingJournal = value;
if (value != null) {
}
}

static CreateGeneralJournal($this: any): any{let entry = new Domain.GeneralJournal();
entry.DatePosted = moment().toDate();
Domain.GeneralJournal.setFiscalPeriod(entry, $this?.FiscalPeriod);
Domain.GeneralJournal.setEntity(entry, $this?.Entity);
Domain.GeneralJournal.setLedger(entry, $this?.Ledger);
Domain.GeneralJournal.setJournal(entry, $this?.AccountingJournal);
for (let _idetail = 0; _idetail < ($this?.Details == null ? 0 : $this?.Details.length); _idetail++) {let detail = $this?.Details[_idetail];let line = new Domain.GeneralJournalDetail();if (detail?.Type == Domain.GeneralJournalTemplateDetailType.SpecificAccount) {Domain.GeneralJournalDetail.setAccount(line, detail?.Account?.TAccount);}Domain.GeneralJournalDetail.setTemplateRef(line, detail);entry?.GeneralJournalDetails?.add(line);}
return entry;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}